import { NAME_SPACE as ns } from './constants';

export const SET_TYPE = `${ns}_SET_TYPE`;

export const SET_FROM_AND_TO = `${ns}_SET_FROM_AND_TO`;
